export enum EExamKey {
  TYT = 'tyt',
  AYT = 'ayt',
}
